import { schema } from 'normalizr';

export const leagueSchema = new schema.Entity('leagues');
export const leagueListSchema = [ leagueSchema ];

export const leagueMPPSchema = new schema.Entity('leaguesMPP');
export const leagueMPPListSchema = [ leagueSchema ];

export const leagueActiveMPPSchema = new schema.Entity('leaguesActiveMPP');



// WEBPACK FOOTER //
// ./src/schemas/league.js